export default __webpack_public_path__ + "static/media/quarantine_portraits.ffc16a1e.png";